// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"e6aff708","242":"faa6ea3f","602":"b6df7683","902":"927ffd0c"}[chunkId] + ".chunk.js";
};